module.exports = __webpack_public_path__ + "static/media/Fleet.9546b128.svg";